import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ApiError, MessageService } from '../../../../../core';
import { RepresentanteProdutividadeWidgetState, RepresentanteProdutividadeWidgetTabs } from './representante-produtividade-widget.state';
import { RepresentanteProdutividadeWidgetStateService } from './representante-produtividade-widget.state.service';
import { Observable, Subscription } from 'rxjs';
import { RepresentanteKPIFilter } from '../../kpis/adapters';
import { RepresentanteKPIsHttpService } from '../../kpis/services';
import { RepresentanteProdutividadeGeralKPITableComponent } from '../../kpis/components/produtividade-geral-table';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sgt-representante-produtividade-widget',
    templateUrl: './representante-produtividade-widget.component.html',
    styleUrls: ['./representante-produtividade-widget.component.less'],
    providers: [
        RepresentanteProdutividadeWidgetStateService
    ]
})
export class RepresentanteProdutividadeWidgetComponent implements OnInit, OnDestroy {
    /** ID do widget */
    @Input() id: string;
    /** Title do widget */
    @Input() title = 'Produtividade Representantes';
    /** Subtitle do widget */
    @Input() subtitle: string = null;
    /** State do widget */
    state: RepresentanteProdutividadeWidgetState;
    /** Subscription do state do widget */
    private state$: Subscription;
    /** Flag que indica se está carregando o widget */
    isLoading$: Observable<boolean>;

    /** Tabs do widget */
    readonly tabs = RepresentanteProdutividadeWidgetTabs;
    /** Table de visualização dos KPIs gerais */
    @ViewChild('geralTable') geralTable: RepresentanteProdutividadeGeralKPITableComponent;

    constructor(private messageService: MessageService,
                private stateService: RepresentanteProdutividadeWidgetStateService,
                private representanteKPIsHttpService: RepresentanteKPIsHttpService) { }

    ngOnInit(): void {
        this.initState();
    }

    /** Inicializando o state do component */
    private initState() {
        // State
        this.state$ = this.stateService.init(true, this.id).subscribe(state => this.state = state);
        // IsLoading
        this.isLoading$ = this.stateService.isLoading$;
    }

    /** Carrega o widget */
    load(filter: RepresentanteKPIFilter) {
        try {
            this.stateService.setIsLoading(true);
            this.representanteKPIsHttpService.getProdutividade(filter)
                .pipe(take(1))
                .subscribe(
                    data => {
                        this.stateService.setData(data);
                        setTimeout(() => this.afterLoad(filter?.periodicidade.periodicidade), 0);
                    },
                    (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                    () => this.stateService.setIsLoading(false)
                );
        } catch (error) {
            this.messageService.error('Tente atualizar a página e se o erro persistir entre em contato com o suporte', `Erro ao carregar os KPI's de Produtividade Mensais`, error);
        }
    }

    /** Após carregar o widget */
    private afterLoad(periodicidade: number) {
        // Geral
        this.geralTable?.show(periodicidade)
    }

    /** Seta a tab ativa */
    setActiveTab(tab: RepresentanteProdutividadeWidgetTabs) {
        this.stateService.setActiveTab(tab);
    }

    ngOnDestroy(): void {
        this.state$?.unsubscribe();
    }
}
